import React from 'react';

export const Switch = ({ checked, onCheckedChange, ...props }) => (
  <button
    onClick={() => onCheckedChange(!checked)}
    className={`relative inline-flex items-center h-6 rounded-full w-11 ${checked ? 'bg-blue-600' : 'bg-gray-300'}`}
    {...props}
  >
    <span
      className={`transition-transform duration-200 transform ${
        checked ? 'translate-x-6' : 'translate-x-1'
      } inline-block w-4 h-4 bg-white rounded-full`}
    ></span>
  </button>
);
